export const topicCategories = [
  {
    slug: "star",
    name: "明星动态",
    icon: "ri-user-star-line",
    desc: "行程、路透、官宣，第一时间整理明星台前幕后的公开动态。",
  },
  {
    slug: "show",
    name: "影视热剧",
    icon: "ri-movie-2-line",
    desc: "热播剧口碑走向、大结局争论与主创回应，一次看全。",
  },
  {
    slug: "variety",
    name: "综艺现场",
    icon: "ri-tv-2-line",
    desc: "录制路透、嘉宾阵容、名场面盘点，综艺瓜一网打尽。",
  },
  {
    slug: "netstar",
    name: "网红圈",
    icon: "ri-live-line",
    desc: "直播间名场面、博主之间的互动与翻车现场合集。",
  },
  {
    slug: "fashion",
    name: "时尚造型",
    icon: "ri-shirt-line",
    desc: "红毯、机场、杂志封面造型拆解，好看与翻车都要说。",
  },
  {
    slug: "music",
    name: "音乐现场",
    icon: "ri-music-2-line",
    desc: "演唱会、音乐节与巡演现场的即时热度和现场记录。",
  },
];

export const hotTopics = [
  {
    id: "t1",
    title: "林晚晚深夜街拍生图流出，素颜状态被夸上热搜",
    summary:
      "一组深夜便利店门口的随手拍在凌晨被疯传，没有精修、没有打光，评论区却意外地一边倒夸状态好，话题阅读量两小时破亿。",
    category: "明星动态",
    categorySlug: "star",
    heat: 98.6,
    comments: 12840,
    date: "2026-09-12",
    tags: ["街拍", "生图", "林晚晚"],
    image:
      "https://readdy.ai/api/search-image?query=stylized%20editorial%20night%20city%20scene%20with%20warm%20neon%20bokeh%20and%20soft%20glow%20abstract%20magazine%20art%20warm%20orange%20tones&width=800&height=600&seq=gua-star-01&orientation=landscape",
    author: "瓜田观察员",
    content: [
      "事情起因其实很简单。凌晨一点多，有路人在便利店门口拍到林晚晚买宵夜，随手发到社交平台，配文只有一句「这也太真实了吧」。照片里她没化妆、头发随便扎着、穿着宽松卫衣，完全是收工回家的状态。",
      "按以往经验，这类生图往往会被挑刺。但这次评论区的风向完全反过来：有人说「终于看到一个不用精修的明星」，也有人把照片放大看细节，讨论她的皮肤状态和穿搭比例，话题在两小时内冲到热搜前三。",
      "更有意思的是后续。林晚晚工作室没有发声明，也没让粉丝控评，只在评论区留了个表情。反倒是几家时尚账号主动分析起这身「下楼买宵夜风」的搭配，带动同款卫衣搜索量一夜上涨。",
      "从传播路径看，这条瓜的看点不在于爆料，而在于它打破了很多人的预期。接下来会不会有品牌顺势接上这波热度，值得继续观察。",
    ],
  },
  {
    id: "t2",
    title: "《雾城迷案》大结局口碑两极，编剧深夜回应争议",
    summary:
      "追了六周的悬疑剧收官，结局观众分成两派吵到凌晨。编剧没有删评也没有关评论，反而发了一条长文逐条解释伏笔。",
    category: "影视热剧",
    categorySlug: "show",
    heat: 95.4,
    comments: 9620,
    date: "2026-09-12",
    tags: ["雾城迷案", "大结局", "悬疑剧"],
    image:
      "https://readdy.ai/api/search-image?query=moody%20abstract%20detective%20mood%20board%20with%20foggy%20street%20lamps%20and%20deep%20warm%20shadow%20stylized%20cinematic%20art&width=800&height=600&seq=gua-show-01&orientation=landscape",
    author: "剧集档案馆",
    content: [
      "《雾城迷案》播出六周，靠前四集的高密度信息量圈了一批硬核观众。但昨晚的大结局明显没有满足所有人：一部分人认为收束得干净利落，另一部分人则觉得关键动机交代得太仓促。",
      "争议集中在两处。第一是反派的选择动机，剧里只用了一段闪回带过；第二是主角最后那句台词，被解读出完全相反的两种含义。两拨人在评论区从剧情聊到人性，硬生生把话题顶上了热搜。",
      "编剧随后发出长文，没有情绪化回应，而是列出时间线，说明哪些细节早在第三集就埋下了伏笔，并承认「有一条线确实受篇幅限制没能展开」。这条回应反而让不少打差评的观众回头重看。",
      "对剧集来说，这种两极口碑未必是坏事。数据显示大结局当晚重看率明显上升，讨论热度还在延续。",
    ],
  },
  {
    id: "t3",
    title: "综艺《今晚吃什么》录制路透，两位常驻疑似气氛微妙",
    summary:
      "路透视频里两人全程零交流，被网友截图对比去年的同框画面。节目组暂未回应，粉丝已经开始各自分析。",
    category: "综艺现场",
    categorySlug: "variety",
    heat: 91.2,
    comments: 7840,
    date: "2026-09-11",
    tags: ["今晚吃什么", "录制路透", "综艺"],
    image:
      "https://readdy.ai/api/search-image?query=playful%20abstract%20kitchen%20studio%20set%20with%20warm%20amber%20light%20stylized%20editorial%20collage%20art&width=800&height=600&seq=gua-variety-01&orientation=landscape",
    author: "综艺前线",
    content: [
      "事情从一段几秒的路透开始。视频里《今晚吃什么》新一季录制间隙，两位常驻嘉宾坐在同一张桌子两端，各自看手机，全程没有交流。",
      "本来只是普通画面，但网友翻出上一季的节目物料对比，发现两人当时的互动非常密集。对比图一出，关于「气氛微妙」的猜测迅速发酵。",
      "也有理性的声音提醒，综艺录制强度大、时长长，嘉宾在休息时各看各的手机再正常不过。而且路透往往只截取几秒，很难反映真实相处状态。",
      "目前节目组和当事人均未回应。按以往惯例，新一季预告放出后，这类猜测通常会自然降温，或者被节目里的互动直接打脸。",
    ],
  },
  {
    id: "t4",
    title: "苏哲直播翻车现场：一句话把自己送上热搜",
    summary:
      "本来只是想和粉丝互动，结果一句玩笑被截屏传播。第二天他开了场澄清直播，观看人数反而创了新高。",
    category: "网红圈",
    categorySlug: "netstar",
    heat: 89.7,
    comments: 15320,
    date: "2026-09-11",
    tags: ["苏哲", "直播", "翻车"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20live%20stream%20studio%20setup%20with%20warm%20ring%20light%20glow%20stylized%20pop%20art%20editorial%20look&width=800&height=600&seq=gua-netstar-01&orientation=landscape",
    author: "瓜田观察员",
    content: [
      "苏哲是做美食探店起家的博主，直播间气氛一向随和。前晚他随口开了个关于「同行探店报价」的玩笑，自己笑了两秒就过去了，但切片账号把这个片段单独剪出来发出去。",
      "失去上下文的切片很快被解读成「内涵同行」，转发量一路飙升。苏哲团队当天没有急着删评，而是隔了一晚，用一场完整的直播来回应。",
      "这次澄清直播他没有念稿，而是把当时的完整录屏放出来，让大家自己看前后语境。结果反响不错，很多人表示「看全片确实就是句玩笑」。直播间在线人数反而刷新了他的个人纪录。",
      "这件事也再次说明，在切片时代，任何一句随口的话都可能脱离语境单飞。对内容创作者来说，这算是一堂公开课。",
    ],
  },
  {
    id: "t5",
    title: "年度盛典红毯造型大盘点：这次到底谁赢麻了",
    summary:
      "一场颁奖礼的红毯，被网友剪成了十几版对比视频。有惊艳的，也有被造型师坑了的，我们按讨论度逐个拆解。",
    category: "时尚造型",
    categorySlug: "fashion",
    heat: 87.3,
    comments: 6180,
    date: "2026-09-10",
    tags: ["红毯", "造型", "盛典"],
    image:
      "https://readdy.ai/api/search-image?query=elegant%20abstract%20runway%20and%20red%20carpet%20mood%20board%20with%20silk%20textures%20and%20warm%20gold%20light%20stylized%20fashion%20editorial&width=800&height=600&seq=gua-fashion-01&orientation=landscape",
    author: "造型研究所",
    content: [
      "年度盛典的红毯向来是造型实力的直接较量。今年的话题度尤其高，从礼服廓形到发型配色，几乎每一套都被逐帧分析过。",
      "讨论度最高的几套有个共同点：剪裁干净、配色克制。反而是一些堆砌了大量元素的造型，虽然单看细节精致，放在整体画面里却显得杂乱，被网友戏称为「用力过猛」。",
      "配饰也成了今年的分水岭。有人用一件耳饰点睛，有人则戴满全身。从传播数据看，简洁款被二次创作的比例明显更高，也更适合出圈。",
      "当然，红毯造型的成败往往是团队、光线、角度共同作用的结果。截图有时会放大缺点，看完整视频又是另一回事。",
    ],
  },
  {
    id: "t6",
    title: "音乐节现场突降大雨，主唱冒雨唱完全场观众集体亮灯",
    summary:
      "压轴演出唱到一半暴雨突至，主办方一度考虑暂停，主唱却选择继续。台下几万人打开手机灯，现场画面刷屏社交平台。",
    category: "音乐现场",
    categorySlug: "music",
    heat: 84.9,
    comments: 5210,
    date: "2026-09-10",
    tags: ["音乐节", "现场", "大雨"],
    image:
      "https://readdy.ai/api/search-image?query=atmospheric%20outdoor%20music%20festival%20stage%20with%20warm%20stage%20lights%20and%20rain%20glow%20stylized%20abstract%20art&width=800&height=600&seq=gua-music-01&orientation=landscape",
    author: "现场记录者",
    content: [
      "这场音乐节的压轴演出赶上了天气预报没料到的暴雨。雨水打在舞台灯光上，画面反而意外地好看，但出于安全考虑，主办方一度准备暂停。",
      "主唱和乐队简单商量后决定继续，只把设备做了防水处理，把原本的曲目顺序调整了一下，用最快的节奏把演出推完。台下观众没有散，反而集体打开了手机灯。",
      "那几分钟的现场视频随后刷屏。有人感慨「这才是现场的意义」，也有人提醒主办方后续要优化应急预案。主办方第二天发布了说明，承认准备不足并公布了补偿方案。",
      "一场意外的雨，既留下了名场面，也暴露了户外演出的组织短板。热度之外，这份说明同样值得关注。",
    ],
  },
  {
    id: "t7",
    title: "顾一舟新剧官宣搭档新人演员，粉丝评论区吵翻了",
    summary:
      "官方海报配文只有一句话，却因为搭档人选引发热议。有人期待新组合，有人担心番位和资源，讨论持续了整整一天。",
    category: "明星动态",
    categorySlug: "star",
    heat: 82.5,
    comments: 8870,
    date: "2026-09-09",
    tags: ["官宣", "新剧", "顾一舟"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20film%20poster%20collage%20with%20warm%20amber%20gradient%20and%20soft%20grain%20stylized%20editorial%20art&width=800&height=600&seq=gua-star-02&orientation=landscape",
    author: "剧集档案馆",
    content: [
      "顾一舟的新剧官宣来得很突然，海报只发了主演剪影和一句「敬请期待」。正式阵容随后出现在备案信息里，搭档是一位刚出道不久的新人演员。",
      "消息一出，评论区立刻分成两派。一派认为新鲜组合值得期待，新人往往更有冲劲；另一派则担心作品的宣发资源会向某一方倾斜。",
      "客观看，这类争论在每次官宣时都会出现。真正决定口碑的，还是剧本和成片质量。过去几年也有不少被质疑的「不被看好组合」，最后靠作品翻身。",
      "目前剧组已进入围读阶段，预计年底开机。后续的选角细节和拍摄进度，我们会持续跟进。",
    ],
  },
  {
    id: "t8",
    title: "《深夜食堂3》宣布定档，原班人马确认回归",
    summary:
      "时隔两年，这部治愈系剧集终于定档。官方只放出一张暖光海报，却让老观众集体回忆杀，评论区瞬间被菜品名刷屏。",
    category: "影视热剧",
    categorySlug: "show",
    heat: 79.8,
    comments: 4320,
    date: "2026-09-09",
    tags: ["深夜食堂3", "定档", "治愈"],
    image:
      "https://readdy.ai/api/search-image?query=cozy%20warm%20late%20night%20diner%20interior%20with%20amber%20lantern%20glow%20stylized%20illustrative%20editorial%20art&width=800&height=600&seq=gua-show-02&orientation=landscape",
    author: "剧集档案馆",
    content: [
      "《深夜食堂》系列一直有一批稳定的老观众。这次第三季定档的消息，只用一张暖色海报和一句「老地方，老时间」就完成了预热。",
      "海报里没有人物，只有一盏灯、一张吧台和一碗汤。但这足以让老观众回忆起前两季的名场面，评论区很快被剧中的菜品名刷屏。",
      "官方同时确认，主要常驻角色为原班人马，同时会加入几位新的单元故事主角。制作方表示，本季依然保持每集一个独立故事的结构。",
      "对一部慢节奏治愈剧来说，能在两年后原班回归并不容易。定档消息发布当天，前两季的重温数据也有了明显回升。",
    ],
  },
  {
    id: "t9",
    title: "网红夫妻档官宣分手，评论区比正片还精彩",
    summary:
      "两人从情侣日常做到百万粉，分手声明却写得异常平静。反倒是评论区里，粉丝自动分成了「早就看出」和「完全没想到」两派。",
    category: "网红圈",
    categorySlug: "netstar",
    heat: 77.6,
    comments: 16240,
    date: "2026-09-08",
    tags: ["夫妻档", "分手", "网红"],
    image:
      "https://readdy.ai/api/search-image?query=split%20abstract%20composition%20with%20warm%20and%20cool%20neutral%20tones%20editorial%20pop%20art%20texture&width=800&height=600&seq=gua-netstar-02&orientation=landscape",
    author: "瓜田观察员",
    content: [
      "这对夫妻档账号靠真实的日常记录起家，从租房阶段拍到买房，粉丝一路见证。所以分手声明一出，很多人的第一反应是「不敢相信」。",
      "声明本身写得非常克制，只说「经过慎重考虑决定各自生活」，没有互相指责，也请求大家不要过度解读。这种体面的处理方式反而收获了不少好评。",
      "评论区则热闹得多。有粉丝翻出几个月前的视频，说自己「早就看出状态不对」；也有人表示完全没察觉，感叹镜头前的东西确实不能全信。",
      "值得注意的是，两人在声明中明确表示账号内容会各自保留、不会删除。对内容创作者来说，如何体面地处理个人关系与公开账号的边界，是个持续的课题。",
    ],
  },
  {
    id: "t10",
    title: "选秀节目导师阵容换血，新面孔曝光后讨论度飙升",
    summary:
      "节目组在官宣前先放出一段悬念视频，剪影一出，网友就开始逐帧猜人。正式名单公布后，讨论方向从期待变成了对比。",
    category: "综艺现场",
    categorySlug: "variety",
    heat: 75.2,
    comments: 3980,
    date: "2026-09-08",
    tags: ["选秀", "导师", "阵容"],
    image:
      "https://readdy.ai/api/search-image?query=stylized%20stage%20spotlight%20and%20silhouette%20shapes%20with%20warm%20amber%20and%20deep%20red%20lighting%20abstract%20art&width=800&height=600&seq=gua-variety-02&orientation=landscape",
    author: "综艺前线",
    content: [
      "新一季选秀的导师阵容一直是关注焦点。节目组这次没有一次性公布，而是先放出一段十几秒的剪影视频，把悬念拉满。",
      "剪影发布当晚，网友就开始逐帧分析身形和动作习惯，各种猜测版本层出不穷。这种「猜人」式的预热，本身就成了第一波话题。",
      "正式名单公布后，讨论方向迅速转向对比：新导师的资历、风格与往季有何不同，能否带出不一样的选手。也有人怀念前几季的导师组合。",
      "对节目来说，换血是必然选择。但导师只是变量之一，选手质量与赛制设计才是决定节目能否走远的关键。",
    ],
  },
  {
    id: "t11",
    title: "春季穿搭模板：普通人也能直接抄的三套公式",
    summary:
      "与其盯着红毯造型发愁，不如看这三套可复制的日常搭配。我们用最基础的单品，拆解出通勤、约会、周末三种场景的解法。",
    category: "时尚造型",
    categorySlug: "fashion",
    heat: 72.4,
    comments: 2760,
    date: "2026-09-07",
    tags: ["穿搭", "日常", "公式"],
    image:
      "https://readdy.ai/api/search-image?query=neutral%20minimal%20wardrobe%20flat%20lay%20with%20cream%20and%20camel%20tones%20soft%20warm%20light%20editorial%20styling&width=800&height=600&seq=gua-fashion-02&orientation=landscape",
    author: "造型研究所",
    content: [
      "很多穿搭内容看起来很美，但一到自己身上就水土不服。问题通常不在单品，而在于没有把场景和比例考虑进去。",
      "第一套是通勤公式：挺括外套加直筒长裤，颜色控制在两种以内，靠版型而不是花纹取胜。第二套是约会公式：用一件有质感的内搭配基础外套，把重点放在材质对比上。",
      "第三套是周末公式：宽松上衣配修身下装，或者反过来，保证整体只有一个「松」的点。这样即便单品都很普通，画面也不会散。",
      "这三套的共同逻辑是「减少变量」。真正好穿的搭配，往往不是元素多，而是每个元素都各司其职。",
    ],
  },
  {
    id: "t12",
    title: "乐队巡演最后一站宣布加场，门票开售即秒空",
    summary:
      "原定三站的巡演因为呼声太高临时加场，结果加场票在开售几十秒内售罄。有人晒出排队截图，也有人吐槽抢票体验。",
    category: "音乐现场",
    categorySlug: "music",
    heat: 70.1,
    comments: 3140,
    date: "2026-09-07",
    tags: ["巡演", "加场", "门票"],
    image:
      "https://readdy.ai/api/search-image?query=abstract%20concert%20venue%20with%20warm%20stage%20beam%20and%20crowd%20silhouette%20stylized%20art%20editorial&width=800&height=600&seq=gua-music-02&orientation=landscape",
    author: "现场记录者",
    content: [
      "这支乐队的巡演本来只安排了三站。首站开票当天就售罄，第二站紧随其后，社交平台上求票的帖子越来越多，主办方随后宣布加场。",
      "加场消息发布后，粉丝的反应两极：抢到的在庆祝，没抢到的开始研究黄牛和转票规则。也有不少人把讨论重点放在抢票体验上，呼吁优化购票流程。",
      "主办方随后补充说明，加场不做二次加价，并公布了官方转票渠道，试图压缩黄牛的生存空间。这个动作获得了不少好评。",
      "从数据看，这支乐队的现场号召力确实在上升。但巡演能否维持热度，还要看后续几站的现场口碑能不能撑住。",
    ],
  },
];

export const testimonials = [
  {
    name: "阿茶不加糖",
    role: "老瓜友 · 追更两年",
    text: "以前刷热搜得来回翻好几个平台，现在打开榜单就大概知道今天大家在聊什么，省事太多了。",
  },
  {
    name: "加班到十点",
    role: "通勤党",
    text: "最喜欢今日速递那条时间线，地铁上五分钟就能把一天的热点过一遍，还不至于被标题党带跑。",
  },
  {
    name: "慢半拍的小周",
    role: "偶尔吃瓜",
    text: "写得挺克制的，会提醒哪些只是猜测、哪些已经有回应，这点比很多只会起标题的地方强。",
  },
  {
    name: "在逃策划",
    role: "内容从业者",
    text: "分类做得清楚，找选题的时候直接按影视、综艺、网红几个栏目翻，效率比自己搜高不少。",
  },
];

export const faqs = [
  {
    q: "黑料瓜网的内容是从哪里来的？",
    a: "我们只聚合公开平台上已经被大量讨论的娱乐话题，再做时间线和背景梳理。所有人物与事件均经过虚构化处理，不代表任何真实个人，也不收录未经证实的指控。",
  },
  {
    q: "吃瓜榜单是怎么排出来的？",
    a: "榜单主要参考话题的讨论量、转发增速和持续时间三个维度综合计算，每两小时更新一次。热度高低只反映讨论规模，不代表我们对话题真伪的判断。",
  },
  {
    q: "多久更新一次？",
    a: "今日速递和吃瓜榜单为持续更新，热门话题推荐每天早晚各整理一次。遇到突发的大型话题，会临时增加更新频率。",
  },
  {
    q: "可以投稿爆料吗？",
    a: "可以。页面上提供了投稿入口，写下你想聊的话题线索和必要的背景说明即可。我们会先做核实与脱敏处理，再决定是否整理成稿。",
  },
  {
    q: "你们会不会传播不实信息？",
    a: "不会。凡是尚未有明确回应或权威来源的内容，我们都会在正文中标注为「待确认」，并明确区分事实与网友讨论，避免误导。",
  },
];